import Reflux from "reflux";

const EventModifyModalAction = Reflux.createActions(["initialLoad", "updateDate", "saveEventChanges", "removeEntity", "removeClinStage", "addClinStage", "addEntity", "addIndustry", "removeIndustry"]);

window.EventModifyModalAction = EventModifyModalAction;
export default EventModifyModalAction;
